module.exports = __webpack_public_path__ + "static/icon-stats-d540f7daa4cbfa55e8da659f3f86a853.png";